module.exports = __webpack_public_path__ + "static/media/left_arrow_enable.a0f67ffe.svg";